module.exports = __webpack_public_path__ + "static/media/crm-heat-mapping.49257424.jpg";